import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import * as screenfull from 'screenfull';

import {addAssembledAppEnv} from './app-env';
import AppState from './app-state';
import {oeInterfaceManager} from '../react-oe/oe-interface';
import OEInterfaceAdapter from '../react-oe/oe-interface-adapter';
import {OEShowInitiallyFlags} from '../lib/oe-types';
import OEToolbox from '../lib/tools/oe-toolbox';

export class AppStateController extends React.Component {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.props.appEnv.component.appStateController = this;

        this.isFullscreen = this.props.appEnv.state.isFullscreen;

        this.onFullscreenChange = this.onFullscreenChange.bind(this);

        this.initialSetFlags = {};

        this.props.appEnv.setState(this.initialState(this.props.appEnv.state));
    }

    showFullscreenBtn(show)    {
        show = !!show && screenfull.isEnabled && this.props.appEnv.state.isFullscreenAvailable;
        this.props.appEnv.setState({showFullscreenBtn: show});
    }

    setFullscreen(fullscreen, force)   {
        if(!screenfull.isEnabled) return;
        fullscreen = !!fullscreen && (this.props.appEnv.state.isFullscreenAvailable || force);

        if(screenfull.isFullscreen == fullscreen)   return;     // do not remove this, since screenfull is not save with respect of calling request/exit when it is already in the demanded state

        if(fullscreen) {
            screenfull.request();
        } else {
            screenfull.exit();
        }
    }

    showDevTools(show)  {
        this.props.appEnv.setState({showDevTools: !!show});
    }
    
    componentDidMount()    {
        this.updateIsFullScreenState();
        if(screenfull.isEnabled)  screenfull.on('change', this.onFullscreenChange);
    }

    componentWillUnmount()    {
        if(screenfull.isEnabled)  screenfull.off('change', this.onFullscreenChange);
    }

    componentWillReceiveProps(nextProps) {
        if(!OEToolbox.shallowEqual(nextProps.appEnv.config, this.props.appEnv.config, true))  {
            this.updateStateForConfigChange(nextProps.appEnv.config, this.props.appEnv.config, nextProps.appEnv.state, this.props.appEnv.state);
        }
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.moduleId !== this.props.moduleId;
    }

    onConnect()   {
    }

    onRelease()   {
    }

    initialState(state)  {
        state = clone(state) || new AppState();
        state.isFullscreenAvailable = this.props.appEnv.config.isFullscreenAvailable && screenfull.isEnabled;
        state.showFullscreenBtn = state.isFullscreenAvailable && OEShowInitiallyFlags.resolve(this.props.appEnv.config.showFullscreenBtn).show;
        return state;
    }

    updateStateForConfigChange(config, prevConfig, state, prevState) {
        let newState = this.updatedStateForConfigChange(state, prevState, config, prevConfig);
        if(OEToolbox.shallowEqual(newState, state, true))   return;
        this.props.appEnv.setState(newState);
    }

    updatedStateForConfigChange(state, prevState, config, prevConfig)   {
        state = clone(state);
        state.isFullscreenAvailable = config.isFullscreenAvailable && screenfull.isEnabled;
        state.showFullscreenBtn = state.isFullscreenAvailable && state.showFullscreenBtn;
        return state;
    }

    updateStateForCoreConnectionChange(config, state, isReady, released) {
        let newState = this.updatedStateForCoreConnectionChange(state, config, isReady, released);
        if(OEToolbox.shallowEqual(newState, state, true))   return;
        this.props.appEnv.setState(newState);
    }

    updatedStateForCoreConnectionChange(state, config, isReady, released)   {
        state = clone(state);

        let resolved = OEShowInitiallyFlags.resolve(config.showFullscreenBtn);
        if((!resolved.onlyAtStartUp || !this.initialSetFlags.showFullscreenBtn) && resolved.atTargetChange) {
            state.showFullscreenBtn = state.isFullscreenAvailable && resolved.show;
        }
        this.initialSetFlags.showFullscreenBtn = true;

        return state;
    }

    updateIsFullScreenState()    {
        if(!screenfull.isEnabled) return;
        if(this.isFullscreen == screenfull.isFullscreen)    return;
        this.isFullscreen = screenfull.isFullscreen;
        this.props.appEnv.setState({isFullscreen: this.isFullscreen});
    }

    updateState(released)   {
        this.updateStateForCoreConnectionChange(this.props.appEnv.config, this.props.appEnv.state, this.oe.isReady(), released);
    }

    onFullscreenChange()  {
        this.updateIsFullScreenState();
    }

    render() {
        return <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>;
    }
}

AppStateController.defaultProps = {
    moduleId: ''
};

AppStateController.propTypes = {
    moduleId: PropTypes.string,
};

export default addAssembledAppEnv(AppStateController);